import {
  CREATE_PROJECTDISCUSSION_REQUEST,
  CREATE_PROJECTDISCUSSION_SUCCESS,
  CREATE_PROJECTDISCUSSION_FAILURE,
} from "./ProjectDiscussionsTypes";

const initialState = {
  loading: true,
  data: [],
  errorMsg: "",
};

const projectDiscussionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PROJECTDISCUSSION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PROJECTDISCUSSION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: "",
      };
    case CREATE_PROJECTDISCUSSION_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default projectDiscussionReducer;
